import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutes } from './app.routes';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './service/loader/loader.service';
import { LoaderInterceptor } from './loader.interceptors';
import { AppComponent } from './app.component';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import {
  ArcSharedModule,
  BrowserCookieService,
  TokenInterceptor,
  clearStateMetaReducer
} from '@arc/arc-shared-frontend';
import { StoreModule, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { TreeTableModule } from 'primeng/treetable';
/* Import prism core */
import 'prismjs/prism';

/* Import the language you need to highlight */
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-scss';
import 'prismjs/components/prism-typescript';
import { ErrorsComponent } from './errors/errors.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ReviewComponent } from './review/review.component';
import { LayoutComponent } from './layout/layout.component';
import { DocumentsComponent } from './documents/documents.component';
import { PaymentsComponent } from './payments/payments.component';
import { MessageService } from '@arc/aureus';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfigService } from './service/config.service';
import { PayOnEmailService } from './service/pay-on-email.service';
import { DatePipe } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { PacComponent } from './pac/pac.component'
import { TooltipDirective } from './tooltip.directive';
import { TwoDigitDecimaNumberDirective } from './two-digit-decima-number.directive';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { AppMonitoringService } from './service/app-monitoring.service';

export const reducers: ActionReducerMap<any> = {};
export const metaReducers: MetaReducer<any>[] = [clearStateMetaReducer];

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutes,
    BrowserAnimationsModule,
    HttpClientModule,
    StoreModule.forRoot(reducers, {
      metaReducers
    }),
    EffectsModule.forRoot([]),
    ArcSharedModule,
    StoreDevtoolsModule.instrument({
      maxAge: 15
    }),
    TreeTableModule,
    TableModule,
    CheckboxModule,
    CalendarModule
  ],
  declarations: [
    AppComponent,
    ErrorsComponent,
    LayoutComponent,
    DocumentsComponent,
    PaymentsComponent,
    ConfirmationComponent,
    ReviewComponent,
    LoaderComponent,
    HomeComponent,
    PacComponent,
    TooltipDirective,
    TwoDigitDecimaNumberDirective,
    MaintenanceComponent
  ],
  providers: [
    HttpClientModule,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) => {
        return () => {
          return translateService.use('en').toPromise();
        };
      },
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      deps: [AppMonitoringService],
      useFactory: (monitoringService: AppMonitoringService) => {
        return () => monitoringService.init();
      },
      multi: true,
    },
    BrowserCookieService,
    ConfigService,
    PayOnEmailService,
    LoaderService,
    DatePipe,
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
